import { keyBy as _keyBy } from 'lodash';

import OfferEvent from '@core/models/offer/OfferEvent';
import PrimaryMarketOdd from '@models/base/PrimaryMarketOdd';
import PlaceholderOdd from '@models/eventGrid/PlaceholderOdd';
import Market from '@models/offer/Market';
import { SuperOfferKeys } from '@models/offer/enums';
import OddType from '@models/struct/OddType';
import Struct from '@models/struct/Struct';

export function getFilledMarketOdds(
    event: OfferEvent,
    market: Market,
    availableOdds: OddType[] | null,
): PrimaryMarketOdd[] {
    const odds = market.odds;
    // Sometimes sports are not included in the
    // marketTree and then odds can't be filled
    if (!availableOdds || availableOdds.length === 0) {
        return odds;
    }

    const currentOddsMap = _keyBy(odds, 'name');

    return availableOdds.map((oddType) => {
        // Support the case where the odd name is something like {player}
        // for racing, winter sports, etc.
        // The odd will have this interpolated, but the simple odd type will not.
        const oddForType = odds.find((odd) => odd.id === oddType.id);
        const oddTypeName = oddForType?.name ?? oddType.name;

        if (currentOddsMap[oddTypeName]) {
            return currentOddsMap[oddTypeName];
        } else {
            return createPlaceholderOdd(oddType);
        }
    });
}

export function getAvailableOddTypes(
    marketTree: Struct['marketTree'],
    oddTypes: Struct['oddTypes'],
    sportId: number,
    marketId: number,
): OddType[] | null {
    const allOddsInMarket = marketTree[sportId];
    if (!allOddsInMarket) {
        return null;
    }
    const marketInfo = allOddsInMarket.markets[marketId];
    if (!marketInfo) {
        return null;
    }
    return marketInfo
        .odds
        .map((odd) => oddTypes[odd.id]);
}

export function getAvailableOddsForSuper(
    superOfferKey: SuperOfferKeys,
    translate: (label: string) => string,
): OddType[] | null {
    return [
        { id: 0, name: translate(`superOffer.${superOfferKey}.1`) },
        { id: 1, name: translate(`superOffer.${superOfferKey}.X`) },
        { id: 2, name: translate(`superOffer.${superOfferKey}.2`) },
    ];
}

function createPlaceholderOdd(oddType: OddType): PlaceholderOdd {
    return new PlaceholderOdd(
        oddType.id,
        oddType.name,
        0,
        true,
    );
}
